import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function KelimeBulmaTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['kelime-bulma-guclugu-testi']} />;
}
